<template>
  <v-dialog
    :value="value"
    @input="$emit('input')"
    max-width="500px"
    persistent
    content-class="ims-standard-dialog"
  >
    <v-card class="ims-modal-card">
      <v-card-title class="title ims-modal-header">
        <span>AM / CC Inputs</span>
        <v-spacer></v-spacer>
        <v-btn icon color="secondary" aria-label="Close" title="Close" @click="close()">
          <v-icon>close</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text class="body-2 ims-modal-body" style="padding-top:30px" v-if="campaign">
        <div v-if="campaign.AMInputs">
          <h4 class="font-weight-bold">AM Inputs</h4>
          <hr style="margin-top:10px">
          <div>
            <label>Please provide an overview of this campaign brief, include pointers to note for your stakeholders to support in getting the brief approved, ie past conversations with client</label>
            <v-textarea
              dense
              v-model="campaign.AMInputs.remarks"
              type="text"
              placeholder=""
              readonly
              outlined
            ></v-textarea>
          </div>
          <div>
            <label>Deadline</label>
            <v-text-field
              v-model="campaign.AMInputs.deadline"
              append-icon="event"
              outlined
              readonly
              v-on="on"
            ></v-text-field>
          </div>
        </div>
        <div v-if="campaign.CCInputs">
          <h4 class="font-weight-bold">CC Inputs</h4>
          <hr style="margin-top:10px">
          <div>
            <label>Please schedule a call with your respective AM to finalise the brief and provide a summary on the following next steps:<br>What are you getting out of this campaign brief and type of rejections/challenges or stucks you foresee from the creators</label>
            <v-textarea
              dense
              v-model="campaign.CCInputs.remarks"
              type="text"
              placeholder=""
              readonly
              outlined
            ></v-textarea>
          </div>
          <div>
            <label>Deadline</label>
            <v-text-field
              v-model="campaign.CCInputs.deadline"
              append-icon="event"
              outlined
              readonly
              v-on="on"
            ></v-text-field>
          </div>
        </div>
      </v-card-text>
      <v-card-actions class="ims-modal-actions">
        <v-btn color="secondary" id="close" text @click.native="close()">Close</v-btn>
        <v-spacer></v-spacer>
        <v-btn color="primary" @click="proceedBrief()" v-if="isSuperAdmin && source === 'release'">Proceed with brief</v-btn>
      </v-card-actions>
    </v-card>
    <loading
      :active.sync="isLoading"
      :can-cancel="false"
      :is-full-page="true"
      loader="bars"
      background-color="#000"
      color="secondary"
      width.number="90"
      height.number="90"
    ></loading>
  </v-dialog>
</template>
<script>
// import userAPIs from '../User/userAPIs';
import config from '@/config';
// import moment from 'moment'
// import { mapState } from 'vuex';
import Loading from 'vue-loading-overlay';
export default {
  name: 'AmCcInputsModal',
  components: {
    Loading
  },
  props: {
    value: Boolean,
    campaign: Object,
    source: String
  },
  data () {
    return {
    }
  },
  async mounted() {
  },
  computed: {
    isSuperAdmin: function() {
      return Number(this.$store.state.user.role) === config.userRoles.SUPER_ADMIN_HIGH
    }
  },
  methods: {
    proceedBrief() {
      this.close()
      this.$emit('proceedBrief', this.campaign)
    },
    close() {
      this.$emit('input')
    }
  }
};
</script>



// WEBPACK FOOTER //
// AmCcInputsModal.vue?4d3aed36